// @flow

import './index.scss';
import * as React from 'react';
import { observer } from 'mobx-react';
import AdCard from '../AdCard';
import Icon from 'components/Icon';
import devicesStore from 'stores/devices';
import {
    CarouselProvider,
    Slider,
    Slide,
    ButtonBack,
    ButtonNext
} from 'pure-react-carousel';

import type { Ad } from 'stores/api/ads';

type Props = {|
    ads: Ad[]
|};

const AdFeatured = ({ ads }: Props): React.Node => (
    <div className="AdFeatured">
        <CarouselProvider
            naturalSlideWidth={100}
            totalSlides={ads.length}
            visibleSlides={devicesStore.isSmallDesktop ? 1 : 2}
            isIntrinsicHeight
            isPlaying
            infinite
        >
            <ButtonBack className="AdFeatured__back-button">
                <Icon type="chevronback" />
            </ButtonBack>
            <Slider className="AdFeatured__slider" infinite>
                {ads.map((ad: Ad) => (
                    <Slide
                        key={ad.id}
                        className="AdFeatured__slide"
                    >
                        <AdCard ad={ad} />
                    </Slide>
                ))}
            </Slider>
            <ButtonNext className="AdFeatured__next-button">
                <Icon type="chevronnext" />
            </ButtonNext>
        </CarouselProvider>
    </div>
);

export default (observer(AdFeatured): typeof AdFeatured);
